import axios from '@configs/axios'

export const getBalancePerCountryAPI = async(selectedApp) => {
  const response = await axios.get(`/reports/balance-per-country?app_id=${ selectedApp?.id }`)
  return response?.data
}
